import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { useEffect } from 'react';
import { getCookieConsentConfiguration } from '../../constants/CookieConsent';
import { CONFIG } from 'src/constants/config';
import { getTargetCookieUserConsentStatus } from '../../utils/CookieConsent';

// Interface for the onConsent and onChange callbacks
interface ConsentCallbackData {
  cookie: {
    categories: string[];
  };
  changedCategories: string[];
}

export default function CookieConsentBanner(): JSX.Element {
  const isProduction = process.env.NODE_ENV === 'production';
  const ga4MeasurementId = CONFIG.GA4_MEASUREMENT_ID;
  const gtmId = CONFIG.GTM_ID;

  function updateUserCookieConsent(categories: string[]): void {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: getTargetCookieUserConsentStatus(categories, 'ads'),
        analytics_storage: getTargetCookieUserConsentStatus(
          categories,
          'analytics',
        ),
        ad_user_data: getTargetCookieUserConsentStatus(categories, 'ads'),
        ad_personalization: getTargetCookieUserConsentStatus(categories, 'ads'),
      });
    }
  }

  useEffect(() => {
    if (!isProduction) {
      return;
    }

    CookieConsent.run({
      ...getCookieConsentConfiguration(window.location.origin),
      onConsent: ({ cookie }: Pick<ConsentCallbackData, 'cookie'>) => {
        updateUserCookieConsent(cookie.categories);
      },
      onChange: ({
        changedCategories,
      }: Pick<ConsentCallbackData, 'changedCategories'>) => {
        updateUserCookieConsent(changedCategories);
      },
    });

    if (ga4MeasurementId) {
      const gaScript = document.createElement('script');

      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${ga4MeasurementId}`;
      document.body.appendChild(gaScript);

      const gaInitScript = document.createElement('script');

      gaInitScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag(){window.dataLayer.push(arguments);}
        window.gtag('js', new Date());
        window.gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'wait_for_update': 5000
        });
        window.gtag('config', '${ga4MeasurementId}', {
          'send_page_view': false
        });
      `;
      document.body.appendChild(gaInitScript);
    }

    // Load HubSpot script
    const hubspotScript = document.createElement('script');

    hubspotScript.async = true;
    hubspotScript.defer = true;
    hubspotScript.src = '//js.hs-scripts.com/46975427.js';
    document.body.appendChild(hubspotScript);
  }, [ga4MeasurementId, isProduction]);

  return (
    <>
      {isProduction && gtmId && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          ></iframe>
        </noscript>
      )}
    </>
  );
}
